import axios from 'axios'
import apis from './apiHelper'
import { host } from '../config/env'

export default {
  getTopic (params) {
    return axios({
      method: 'get',
      url: apis.getTopic,
      params: params
    }).then(res => {
      // 手动替换老图片域名：七牛==>腾讯云
      if (res.data && typeof res.data === 'object') {
        const data = JSON.stringify(res.data).replace(/res1\.eqh5/g, 'asset.eqh5').replace(/eqxiu-1251586368\.cos\.ap-shanghai\.myqcloud/g, 'asset.eqh5')
        res.data = JSON.parse(data)
      }
      return res
    })
  },
  saveTopic (params) {
    return axios({
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'post',
      url: apis.saveTopic,
      data: params
    })
  },
  checkOpus (params) {
    return axios({
      method: 'get',
      url: `${host.mtopic}/m/topic/config/checkexist`,
      params: params
    })
  },
  getOpus (params) {
    return axios({
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'post',
      url: `${host.mtopic}/m/topic/config/work`,
      data: params
    })
  },
  packageProduct (params) {
    return axios({
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'post',
      url: apis.packageProductUrl,
      data: params
    })
  },
  getWxShareInfo (params) {
    return axios({
      method: 'post',
      url: apis.getWxShareInfoUrl,
      data: params
    })
  }
}
